<template>
  <div class="companies">
    <SectionHeader>
      <BreadCrumbs
        :items="[
          { text: $t('meta.sites'), name: 'company_sites' },
          { text: site.name, name: 'site', params: { site_uuid: this.$route.params.site_uuid } },
          {
            text: area.name,
            name: 'area',
            params: { site_uuid: this.$route.params.site_uuid, area_uuid: this.$route.params.area_uuid },
          },
          {
            text: zone.name,
            name: 'zone',
            params: {
              site_uuid: this.$route.params.site_uuid,
              area_uuid: this.$route.params.area_uuid,
              zone_uuid: this.$route.params.zone_uuid,
            },
          },
          { name: $t('locationIdentifier.add') },
        ]"
      />
    </SectionHeader>
    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('containers.addIdentifier') }}</h3>
            <div class="header-meta"></div>
          </header>
          <div class="content-body">
            <form @submit.prevent="create_identifier" class="form" method="post">
              <div class="form-wrap">
                <label for="name">{{ $t('meta.name') }}</label>
                <input v-model="identifier.name" class="form-input" type="text" name="name" id="name" />
              </div>

              <!-- Dropdown for identifier types with custom input -->
              <div class="form-wrap select-wrap">
                <label for="identifier_type">{{ $t('containers.identifierType') }}</label>
                <select v-model="identifier.identifier_type_name" class="select-wrap">
                  <option v-for="f in identifier_type_values" :value="f.name" :key="f.name">
                    {{ f.text }}
                  </option>
                </select>
              </div>
              <div
                v-if="identifier.identifier_type_name !== null && identifier.identifier_type_name === 'other'"
                class="form-wrap"
              >
                <label for="custom_identifier_type">{{ $t('containers.customIdentifierType') }}</label>
                <input
                  v-model="identifier.custom_identifier_type"
                  class="form-input"
                  type="text"
                  name="custom_identifier_type"
                  id="custom_identifier_type"
                  :placeholder="$t('containers.customIdentifierTypePlaceholder')"
                />
              </div>

              <div class="form-wrap">
                <label for="value">{{ $t('identifiers.value') }}</label>
                <input v-model="identifier.value" class="form-input" type="text" name="value" id="value" />
              </div>

              <p style="margin: 0">
                <input type="submit" :value="$t('meta.save')" class="button button-green button-100 button-round" />
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav.vue'

import areasApi from '@/api/areas'
import categoryValuesApi from '@/api/categoryValues'
import sitesApi from '@/api/sites'
import zonesApi from '@/api/zones'

export default {
  name: 'zone_identifier',
  data() {
    return {
      site: {},
      area: {},
      zone: {},
      identifier: {},
      identifier_type_values: [],
      custom_identifier_type: '',
    }
  },
  components: { BreadCrumbs, CompanyNav, SectionHeader },
  methods: {
    async getCategoryValues(context, category) {
      this.identifier_type_values = await categoryValuesApi.get(context, category)
    },
  },
  async mounted() {
    ;[this.site, this.area, this.zone] = await Promise.all([
      sitesApi.get(this.$route.params.site_uuid),
      areasApi.get(this.$route.params.site_uuid, this.$route.params.area_uuid),
      zonesApi.get(this.$route.params.area_uuid, this.$route.params.zone_uuid),
    ])
    await this.getCategoryValues('containers', 'identifier_type')
  },
}
</script>
